import {FETCH_REG_PROPS, FETCH_LOCATION, UPDATE_INITIAL_DATA, FETCH_DISTRICTS, SET_TALON_PICTURE, CLEAR_NEW_LIABILITY_POLICY} from '../actions/types';

export const insVehicleInfoReducer = (state = {} , action) => {
    switch(action.type) {
        case FETCH_REG_PROPS:
            return {...state, registrationProps: action.payload } || false;
        case FETCH_LOCATION:
            return {...state, location: action.payload } || false;
        case UPDATE_INITIAL_DATA:
            return {...state, initialData: action.payload } || false;
        case FETCH_DISTRICTS:
            return {...state, districts: action.payload } || false;
        case SET_TALON_PICTURE:
            return {...state, talonPicture: action.payload } || false;
        case CLEAR_NEW_LIABILITY_POLICY:
            return {};

        default:
            return state;
    }
}